export default "__VITE_ASSET__CKpu5npZ__"